import CustomSearchInput from "../components/CustomSearchInput";

document.addEventListener('DOMContentLoaded', () => {
    let projectsFilterForm = document.querySelector('.projects-filter-form')

    if (projectsFilterForm) {
        let municipalDistrictIdSelect = projectsFilterForm.querySelector('[name="municipalDistrictId"]'),
            cityIdSelect = projectsFilterForm.querySelector('[name="cityId"]'),
            cityIdSelectCI = new CustomSearchInput(cityIdSelect, {
                data() {
                    return {
                        districtId: municipalDistrictIdSelect.value
                    }
                },
                url: '/api/cities/paginate',
                class: 'dropdown filter-dropdown',
            })
        municipalDistrictIdSelect.addEventListener('change', () => cityIdSelectCI.loadOptions(null, false))
    }
})
